angular.module('satv.mediastats')
.controller('SubjectListModalCtrl', ['$scope', 'StatLoader', 'config', '$window', '$httpParamSerializer', function($scope, StatLoader, config, $window, $httpParamSerializer) {
    $scope.search = function(searchConfig) {
        $scope.statLoader = new StatLoader(searchConfig).getFirstPage();
    };

    $scope.search($scope.searchConfig);

    $scope.export = function(searchConfig) {
        var params, serializedParams;

        params = angular.copy(searchConfig);
        params._format = 'csv';
        params.pageSize = 0;

        var url = config.apiUri + '/media/stats?' + $httpParamSerializer(params);
        $window.location.href = url;
    };
}]);



// WEBPACK FOOTER //
// ./vendor/sonyatv/mediastatsclientbundle/Resources/js/angular/controllers/SubjectListModalCtrl.js